<!-- 表格封装组件 -->
<template>
  <div class="tableContent">
    <el-table
      ref="tableRef"
      :data="tableData"
      style="font-size: 12px; border-radius: 10px"
      @sort-change="sort_change"
      :max-height="
        tableFunction && tableFunction.height ? tableFunction.height : '100%'
      "
      :cell-class-name="tableCellClassName"
      header-cell-class-name="tableHeader"
      @selection-change="handleSelectionChange"
      border
      :row-class-name="tableRowClassName"
    >
      <!-- 勾选框 -->
      <el-table-column
        v-if="tableFunction && tableFunction.checkData && selectableShow"
        type="selection"
        width="55"
        align="center"
        :selectable="selectable"
      >
      </el-table-column>
      <el-table-column
        v-for="item in columns"
        :prop="item.prop"
        :label="item.label"
        :key="item.prop"
        :sortable="item.sort ? 'custom' : false"
        :align="item.align ? item.align : 'center'"
        :width="item.width ? item.width : ''" 
      >
        <template slot-scope="{ row }">
          <!-- 排序 -->
          <span v-if="item.prop == 'serial'">{{ row.index + 1 }}</span>
          <!-- 操作插槽 -->
          <span v-else-if="item.prop == 'operation'"
            ><slot name="operation" :row="row"
          /></span>
          <!-- 老师推广提成插槽 -->
          <span v-else-if="item.prop == 'teachExtend'"
            ><slot name="teachExtend" :row="row"
          /></span>
          <!-- 学员标签操作 -->
          <span v-else-if="item.prop == 'tags'"
            ><slot name="studentLabel" :row="row"
          /></span>
          <!-- 状态值 -->
          <span v-else-if="item.prop == 'status' && !item.isMyself">
            {{ ~~row[item.prop] ? "启用" : "禁用" }}
          </span>
          <!-- 激活状态 -->
          <span v-else-if="item.prop == 'is_active'">
            {{ ~~row[item.prop] ? "已激活" : "未激活" }}
          </span>
          <!-- 开通商品 -->
          <span v-else-if="item.prop == 'courses'">
            <el-popover placement="right" trigger="hover">
              <div style="width: 300px">{{ row[item.prop].join(",") }}</div>
              <div class="over5" slot="reference">
                {{ row[item.prop].join(",") }}
              </div>
            </el-popover>
          </span>

          <!-- 员工备注 -->
          <span v-else-if="item.prop == 'employRemark'">
            <el-popover
              placement="right"
              trigger="hover"
              v-if="row[item.prop].length > 15"
            >
              <div style="width: 300px">{{ row[item.prop] }}</div>
              <div class="over5" slot="reference">
                {{ row[item.prop] }}
              </div>
            </el-popover>
            <div v-else>
              {{ row[item.prop] }}
            </div>
          </span>

          <!-- 视频总量/免费试听 -->
          <span v-else-if="item.prop == 'couseNum'">
            {{ row.video_count }}/{{ row.video_free_count }}
          </span>

          <!-- 实付价格 -->
          <span v-else-if="item.prop == 'fee'">
            {{ row[item.prop] ? row[item.prop] : "用户激活后扣费" }}
          </span>

          <!-- 退款操作 -->
          <span v-else-if="item.prop == 'tuikuanStatus'">
            <span v-if="!row[item.prop]">待审核</span>
            <span v-else-if="row[item.prop] == 1" style="color: green"
              >已通过</span
            >
            <span v-else style="color: red">未通过</span>
          </span>

          <!-- 自有插槽-->
          <span v-else-if="item.isMyself">
            <slot :name="item.prop" :row="row" />
          </span>
          <!-- 普通情况 -->
          <span v-else>{{ row[item.prop] }}</span>
        </template>
      </el-table-column>

      <!-- 暂无数据 -->
      <template slot="empty">
        <el-empty :image-size="100" description="暂无数据"></el-empty>
      </template>
    </el-table>
  </div>
</template>

<script>
export default {
  name: "TableComponents",
  props: {
    columns: {
      type: Array,
      default: () => [],
    },
    tableData: {
      type: Array,
      default: () => [],
    },
    tableFunction: {
      type: Object,
      default: () => {},
    },
    allSelectedStatus: {
      type: Boolean,
      default: false,
    },
    allStatus:  {
      type: Boolean,
      default: false,
    },
    selectableShow:  {
      type: Boolean,
      default: false,
    },
  },
  computed: {},
  data() {
    return {};
  },
  watch: { 
    allSelectedStatus: {
      handler(_newVal) {
        console.log("_newVal", _newVal)
        this.$refs.tableRef.clearSelection()
        if (_newVal) {
          this.tableData.forEach(item => {
            this.$refs.tableRef.toggleRowSelection(item)
          })
        } 
      },
      deep: true,
    }, 
    allStatus: {
      handler(_newVal) { 
        if (_newVal) {
          this.$refs.tableRef.clearSelection() 
        } 
      },
      deep: true,
    },
  },
  created() {},
  methods: {
    tableRowClassName({ row, rowIndex }) {
      if ((rowIndex + 1) % 2 == 0) {
        return "warning-row-color";
      }
      return "";
    },
    sort_change(column) {
      //排序
      //  'column',column)
      if (column.order == "ascending") {
        this.tableData = this.tableData.sort((a, b) => {
          return a[column.prop] - b[column.prop];
        });
      } else if (column.order == "descending") {
        this.tableData = this.tableData.sort((a, b) => {
          return b[column.prop] - a[column.prop];
        });
      }
    },
    //利用单元格的 className 的回调方法，给行列row、column索引赋值
    tableCellClassName({ row, column, rowIndex, columnIndex }) {
      //注意这里是解构
      row.index = rowIndex;
      column.index = columnIndex;
    },
    selectable(row, index) {
      if(this.allStatus){
        return false;
      }else{ 
        if (this.tableFunction.name == "dialogGoods") {
          return !row.user_power;
        } else {
          return true;
        }
      }
    },
    handleSelectionChange(val) {
      this.$emit("choiceGoods", val);
    },
  },
};
</script>
<style lang="less" scoped></style>
